
export const ReportMacrosMy: string = 'my_macros'
export const ReportMacrosAcc: string = 'acc_macros'

export type ReportMacrosCategory = 'my_macros' | 'acc_macros'
